import { Component } from '@angular/core';

@Component({
  selector: 'app-segunda-via-boleto',
  templateUrl: './segunda-via-boleto.component.html',
  styleUrls: ['./segunda-via-boleto.component.scss'],
})
export class SegundaViaBoletoComponent {}
